import { useEffect, useState } from 'react';

export default function GeocodeHelper({ customersToGeocode, onGeocodeComplete }) {
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!customersToGeocode || customersToGeocode.length === 0 || isGeocoding) return;

    const geocodeAll = async () => {
      setIsGeocoding(true);
      setProgress(0);
      const results = [];
      const apiKey = "AIzaSyALpDWAlpYMJc5RtcLG31oOvXYVRmwthXw";

      for (let i = 0; i < customersToGeocode.length; i++) {
        const c = customersToGeocode[i];
        
        try {
          const response = await fetch('/api/customers/geocode', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              cd_no: c.cd_no,
              address: c.address,
              city: c.city,
              search_name: c.search_name,
              customer_name: c.customer_name,
              api_key: apiKey
            })
          });
          
          const data = await response.json();
          
          if (data.status === 'success') {
            results.push({
              cd_no: c.cd_no,
              lat: data.lat,
              lng: data.lng,
              status: data.geocode_status
            });
          } else {
            console.warn("Backend geocode error for", c.cd_no, data.message);
            results.push({ cd_no: c.cd_no, status: 'failed' });
          }
        } catch (e) {
          console.error("Network error during geocoding", e);
          results.push({ cd_no: c.cd_no, status: 'failed' });
        }
        
        setProgress(i + 1);
      }

      setIsGeocoding(false);
      if (onGeocodeComplete) onGeocodeComplete(results);
    };

    geocodeAll();

  }, [customersToGeocode, isGeocoding, onGeocodeComplete]);

  if (customersToGeocode && customersToGeocode.length > 0) {
    return (
      <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#e0f2fe', borderRadius: '8px', border: '1px solid #bae6fd' }}>
        <h4 style={{ margin: '0 0 0.5rem 0', color: '#0369a1' }}>🤖 Auto-Geocoding in Progress...</h4>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#0c4a6e' }}>
          Processing {progress} of {customersToGeocode.length} customers. Please do not close this page.
        </p>
      </div>
    );
  }

  return null;
}
